// Google Analytics 4 configuration and utilities
import { environment } from '@/config/environment';

export const GA_TRACKING_ID = environment.analytics.googleId;

// Initialize gtag
declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'set',
      targetId: string | Date | object,
      config?: object
    ) => void;
    dataLayer: unknown[];
  }
}

// Track events with enhanced parameters
export const event = (
  action: string,
  {
    event_category,
    event_label,
    value,
    currency = 'USD',
    custom_parameters = {},
    ...parameters
  }: {
    event_category?: string;
    event_label?: string;
    value?: number;
    currency?: string;
    custom_parameters?: Record<string, unknown>;
    [key: string]: unknown;
  } = {}
) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category,
      event_label,
      value,
      currency,
      ...custom_parameters,
      ...parameters,
    });
  }
};

// User properties
export const setUserProperties = (properties: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('set', 'user_properties', properties);
  }
};
